import React from 'react';
import { Box } from '@mui/material';
import CellHealthCertificate from './BatteryScopeV2-C/layout/CellHealthCertificate-2';

const CellHealthCertificatePage = () => {
  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%)',
      padding: 0,
      margin: 0,
      fontFamily: 'Bai Jamjuree',
    }}>
      <CellHealthCertificate />
    </Box>
  );
};

export default CellHealthCertificatePage;
